<template>
  <div class="main" id="imageBox">
    <div class="__box">
      <div class="logo">Photographers101</div>
      <div class="title" v-if="mainImages" v-html="title"></div>
      <div class="__button__box">
        <dropdown-menu-type-1-1
          :data="cities"
          v-model="loadCity"
          title="London"
        />
        <dropdown-menu-type-1
          :data="speciality"
          :base-url="baseUrl"
          title="Property"
          :location="location"
          v-on:model="v => getLandingImage(v)"
        />
      </div>
    </div>
    <div class="text" v-if="mainImages" v-html="text"></div>
    <!--<transition-group name="list" mode="out-in" appear tag="div" class="images">-->
    <div class="images">
      <div
        class="case"
        v-for="(item, index) in mainImagesView"
        v-bind:key="index + 'landing'"
      >
        <img v-if="item" v-fadeInImageLoading="item.mainFullPath" />
        <div class="category">{{ speciality[item.speciality].title }}</div>
      </div>
    </div>
    <!--</transition-group>-->
  </div>
</template>
<script>
import DropdownMenuType1 from './common/DropdownMenuType1.vue'
import { getCities, getSpecialties } from '../api/common_code'
import { getLandingImages } from '../api/landingApi'
import mixCommon from '../mixin/common'
import DropdownMenuType11 from './common/DropdownMenuType1-1'
export default {
  mixins: [mixCommon],
  name: 'landing',
  components: {
    DropdownMenuType11,
    DropdownMenuType1
  },
  data: function() {
    return {
      mainImages: [],
      mainImagesView: [],
      text: '',
      content: '',
      jumpMenu: '',
      dropdownList: [],
      baseUrl: 'main',
      speciality: {},
      cities: {},
      title: '',
      images: [],
      location: 'ia7pJmEWlRBpJih5RNKy',
      loadCategory: 'Lrzxub4vvDSbljcI7mst',
      loadCity: 'ia7pJmEWlRBpJih5RNKy',
      elTarget: ''
    }
  },
  beforeCreate() {
    getSpecialties().then(snap => {
      this.speciality = snap
    })

    getCities().then(snap => {
      this.cities = snap
    })
  },
  watch: {
    loadCity(newValue, oldValue) {
      if (newValue != oldValue) {
        //    this.getLandingImage(this.loadCategory)
      }
    }
    // location (newValue, oldValue) {
    //     if (newValue != oldValue) {
    //         this.location = newValue
    //     }
    // }
  },
  created() {
    // this.getLandingImage('5BZaLDw4JW2sStegkGss')
  },
  mounted() {
    let timer = false
    window.addEventListener('resize', () => {
      console.log('timer:', timer)
      if (!timer) {
        timer = setTimeout(() => {
          timer = false
          // this.showTypeByResolutionSize()
        }, 1000)
      }
    })
    this.$nextTick(() => {
      this.showTypeByResolutionSize()
    })
    // this.getLandingImage(this.loadCategory, 2, this.location).then(() => {
    //     this.showTypeByResolutionSize()
    // })
  },
  methods: {
    showTypeByResolutionSize() {
      this.elTarget = document.querySelector('#imageBox')
      if (this.elTarget) {
        const width = this.elTarget.offsetWidth
        if (width < 800) {
          this.getLandingImage(this.loadCategory, 1)
        } else {
          this.getLandingImage(this.loadCategory, 2)
        }
      } else {
        this.showTypeByResolutionSize()
      }
    },
    randomIndex(size) {
      return Math.floor(Math.random() * size)
    },
    async getLandingImage(speciality, count = 2) {
      await getLandingImages(speciality, this.loadCity).then(snap => {
        // console.log('get landing image:', snap)
        new Promise(resolve => {
          const images = []
          snap.forEach(v => {
            const obj = Object.assign({}, v.image, { speciality: v.speciality })
            images.push(obj)
          })
          resolve(images)
        }).then(result => {
          new Promise(resolve => {
            let bucket = []
            console.log('bucket length:', bucket.length)
            let i = 0
            while (bucket.length < count) {
              if (i >= 1000) {
                alert('Image has not anymore.')
              }
              let randomIndex = this.randomIndex(result.length)
              const newBucket = result[randomIndex]
              if (newBucket.direction === 'width') {
                bucket = []
                bucket.push(newBucket)
                break
              }
              const checkDuplication = bucket.filter(v => {
                console.log(`${v.imageUid} === ${newBucket.imageUid}`)
                return v.imageUid === newBucket.imageUid
              })
              console.log('duplication.length:', checkDuplication.length)
              if (checkDuplication.length === 0) {
                bucket.push(newBucket)
              }
              i++
            }
            resolve(bucket)
          }).then(result => {
            console.log('result:', result)
            this.mainImagesView = result
          })
          // } else {
          //     this.mainImages = result
          //     this.mainImagesView = result
          // }
        })
        this.text = snap[0].text
        this.title = snap[0].title
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.main {
  overflow: hidden;
  position: fixed;
  width: 100%;
  height: 100vh;
  background-color: #000000;

  &::before {
    content: '';
    display: block;
    /*display: none;*/
    position: absolute;
    width: 100%;
    min-height: 100%;
    opacity: 0.5;
    border: 0;
    background-color: #000000;
    z-index: 1;
  }

  .__box {
    position: absolute;
    margin: auto;
    top: 30%;
    left: 0;
    right: 0;
    width: 540px;
    z-index: 1080;
    text-align: center;

    .logo {
      font-size: 48px;
      font-weight: 600;
      margin: auto;
      width: 100%;
      height: auto;
      object-fit: contain;
    }

    .title {
      display: none;
      margin-top: 10px;
      width: 628px;
      height: 46px;
      font-size: 32px;
      font-weight: 300;
      letter-spacing: 1px;
      text-align: center;
      color: #ffffff;
    }

    .__button__box {
      margin: 20px 0 0 0;
      width: calc(100% + 50px);
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .text {
    z-index: 1080;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 20px;
    margin: auto;
    width: 800px;
    height: 64px;
    font-size: 20px;
    font-weight: 300;
    text-align: center;
    color: #ffffff;

    span {
      font-weight: 600;
    }
  }

  .images {
    height: 100vh;
    display: flex;

    .case {
      flex: 1;
      overflow: hidden;
      position: relative;
      border: none;
      outline: none;

      img {
        outline: none;
        border: none;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0;
        margin: auto;
        height: 150%;
        /*width: 110%;*/
        object-fit: cover;
        transition: all 1s ease-in-out;
        //transform: translateX(-10px);
      }

      .category {
        position: absolute;
        background-color: #fff;
      }
    }
  }

  @media (max-width: 1000px) {
    .images {
      .case {
        overflow: hidden;
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 120%;
          object-fit: cover;
          transition: all 0.5s ease-in-out;
        }

        &:nth-child(2) {
          display: none;
        }
      }
    }
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 3s;
}

.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
 {
  opacity: 0;
  transform: translateX(20px);
}
</style>
